import { HudIcon } from '@hud/web-components/Icons/HudIcons';
import styled from 'styled-components';
import { themeColor } from '@hud/web-components/theme/colors';

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ServicesIcon = styled(HudIcon).attrs({
  icon: 'menu.services',
  size: '20px',
})<{ icon?: never }>`
  color: ${themeColor('gray')};
`;
